















  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';
  import { createCollapseAnimationMixin } from './animations.mixin';

  /**
   * Renders a transition wrapping the element passed in the default slot and animating
   * it with a height animation.
   *
   * @public
   */
  @Component({
    mixins: [createCollapseAnimationMixin('height')],
    inheritAttrs: false
  })
  export default class CollapseHeight extends Vue {
    /**
     * Indicates if the transition must be applied on the initial render of the node.
     */
    @Prop({
      type: Boolean,
      default: true
    })
    public appear!: boolean;
    // TODO Add support for extending enter, after-enter and leave transitions
  }
